const setWebPageTitle = (title?: string) => {
    let newTitle = "";
    if (title) {
        newTitle = title + " - Recipins";
    } else {
        newTitle = "Recipins";
    }
    if (newTitle !== document.title) {
        document.title = newTitle;
        document.querySelector('meta[property="og:title"]')?.setAttribute("content", newTitle);
    }
};

export default setWebPageTitle;
